/* istanbul ignore file */
import React from 'react';
import { useFieldHelper, LinkField } from 'framework/ui/field';
import { useProcessDefinitionUrl } from 'domain/gpo/cockpit/definition/processDefinitionRoute';

// @ts-ignore
const ProcessDefinitionLinkField = ({ source, ...props }) => {
  const { getValue: getId } = useFieldHelper({ source });
  const { getSingleEntityUrl } = useProcessDefinitionUrl();
  const id = getId();
  const url = getSingleEntityUrl(id);

  return <LinkField {...props} linkText={id} value={url} isInternal />;
};

export default ProcessDefinitionLinkField;
